import React, { useState, useEffect } from "react";
import "./WeatherStrip.css";

const CITIES = [
    { name: "Toshkent", latitude: 41.2995, longitude: 69.2401 },
    { name: "Samarqand", latitude: 39.6542, longitude: 66.9597 },
    { name: "Buxoro", latitude: 39.7747, longitude: 64.4286 },
    { name: "Xiva", latitude: 41.3783, longitude: 60.3639 },
    { name: "Namangan", latitude: 41.0011, longitude: 71.6722 },
    { name: "Termiz", latitude: 37.2242, longitude: 67.2783 },
];

// WMO ob-havo kodlari → icon
// https://open-meteo.com/en/docs#weathervariables
const getIcon = (code, temp) => {
    if (code === 0) return "☀️";   // Toza osmon
    if (code === 1) return "🌤️";  // Asosan toza
    if (code === 2) return "⛅";   // Qisman bulutli
    if (code === 3) return "☁️";   // To'liq bulutli
    if (code >= 45 && code <= 48) return "🌫️"; // Tuman
    if (code >= 51 && code <= 55) return "🌦️"; // Mayda yomg'ir
    if (code >= 61 && code <= 65) return "🌧️"; // Yomg'ir
    if (code >= 71 && code <= 75) return "❄️";  // Qor
    if (code >= 80 && code <= 82) return "🌧️"; // Kuchli yomg'ir
    if (code >= 95 && code <= 99) return "⛈️"; // Momaqaldiroq
    // Agar kod yo'q bo'lsa, haroratga qarab
    if (temp <= 0) return "❄️";
    if (temp <= 15) return "🌥️";
    if (temp <= 25) return "⛅";
    if (temp <= 32) return "☀️";
    return "🔥";
};

export default function WeatherStrip() {
    const [weathers, setWeathers] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchAll = async () => {
            try {
                const results = await Promise.all(
                    CITIES.map(async (city) => {
                        const res = await fetch(
                            `https://api.open-meteo.com/v1/forecast` +
                            `?latitude=${city.latitude}` +
                            `&longitude=${city.longitude}` +
                            `&current=temperature_2m,weathercode` +
                            `&timezone=Asia%2FTashkent`
                        );
                        const data = await res.json();
                        const temp = Math.round(data.current.temperature_2m);
                        const code = data.current.weathercode ?? -1;

                        return {
                            name: city.name,
                            temp,
                            icon: getIcon(code, temp),
                        };
                    })
                );

                setWeathers(results);
            } catch {
                // Fallback
                setWeathers([
                    { name: "Toshkent", temp: 28, icon: "☀️" },
                    { name: "Samarqand", temp: 25, icon: "⛅" },
                    { name: "Buxoro", temp: 31, icon: "☀️" },
                    { name: "Xiva", temp: 29, icon: "🌤️" },
                    { name: "Namangan", temp: 26, icon: "⛅" },
                    { name: "Termiz", temp: 34, icon: "🔥" },
                ]);
            } finally {
                setLoading(false);
            }
        };

        fetchAll();
        const interval = setInterval(fetchAll, 600000); // 10 daqiqada yangilash
        return () => clearInterval(interval);
    }, []);

    return (
        <div className="weather-strip">
            <div className="weather-strip-inner">
                {loading ? (
                    <span className="weather-loading">Ob-havo yuklanmoqda...</span>
                ) : (
                    <div className="weather-cities">
                        {weathers.map((city, i) => (
                            <div className="weather-city" key={i}>
                                <span className="weather-icon">{city.icon}</span>
                                <span className="weather-name">{city.name}</span>
                                <span className="weather-temp">{city.temp}°C</span>
                                {i < weathers.length - 1 && (
                                    <span className="weather-divider">|</span>
                                )}
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}